var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconoConvenio = function SvgIconoConvenio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h55v55H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icono-convenio_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.997 9.605v-.659c0-1.07-.865-1.94-1.929-1.94H2.929A1.928 1.928 0 0 0 1 8.94v35.03h48V11.547c0-1.07-.865-1.94-1.93-1.94H24.998Z",
    fill: "#E8183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.31 12.404H3.129V44.33H47.31V12.404Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.313 16.397-.713 1.988H2.93c-1.065 0-1.93.87-1.93 1.94V45.06C1 46.13 1.865 47 2.93 47h44.135c1.064 0 1.93-.87 1.93-1.94V17.055c0-1.07-.866-1.94-1.93-1.94H26.131c-.812 0-1.543.51-1.818 1.281Z",
    fill: "#D3122D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 45.06V28.934C35.666 41.978 12.54 45.465 1.538 46.4c.35.37.848.6 1.397.6h44.136c1.064 0 1.93-.87 1.93-1.94ZM20.49 19.943H4.168c-.86 0-1.56.7-1.56 1.57v3.476c2.747-1.894 8.938-4.275 17.882-5.046Z",
    fill: "#BC0C29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icono-convenio_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 7)",
    d: "M0 0h48v40H0z"
  })))));
};
export default SvgIconoConvenio;